<template>
    <div class="rew19_basketList_wrap">
        <h2>
            <span class="rew19_basketList_tit">주문완료</span>
        </h2>
    
        <div class="rew19_order_box end" id="oArea">
            <template v-if="mode != 'NTC'">
                <p class="flex">
                    정기구매 주문이 완료되었습니다.
                    <span>
                        회원님께서 신청하신 정기구매 번호는 <em class="rew19_point">{{viewData.aro_no}}</em>입니다.<br/>
                        <span v-if="paymentCase == '1'">
                          익월부터는 신청하신
                          <em class="rew19_point">{{viewData.delivery_day}}</em>
                          일에 주문하신 물품이 배송됩니다.<br/>
                          휴일 또는 배송이 밀리는 경우 1~2일 정도 배송이 지연될 수 있습니다.
                        </span>
                        <span v-else-if="paymentCase == '2' || paymentCase == '3'">
                          익월 부터는
                          <em class="rew19_point">{{parseInt(viewData.delivery_day, 10)-7}}</em>
                          일에 자동 결제 되어 3일 이내(영업일 기준)에 배송될 예정입니다.<br/>
                          배송이 밀리는 경우 1~2일 정도 배송이 지연될 수 있습니다.
                        </span>
                        <span v-else>
                          익월 부터는
                          <em class="rew19_point">{{viewData.delivery_day}}</em>
                          일에 자동 결제 되어 3일 이내(영업일 기준)에 배송될 예정입니다.<br/>
                          배송이 밀리는 경우 1~2일 정도 배송이 지연될 수 있습니다.
                        </span>
                    </span>
                </p>
                <button class="rew19_btn_T1" type="button" @click="goMyDetail('ARO')">주문내역 보기</button>
            </template>

            <template v-if="mode == 'NTC'">
                <p class="flex">
                    NTC 정기 기부 신청이 완료되었습니다.
                    <span>
                        익월부터는 신청하신 <em class="rew19_point">{{viewData.payment_date}}</em>일에 매월 결제가 이루어집니다.<br/>
                    </span>
                </p>
                
                <button class="rew19_btn_T1" type="button" @click="goMyDetail('NTC')">나의 NTC 가기</button>
            </template>
        </div>
    
        <div class="rew19_completeList">
            <dl class="rew19_paymentGroup">
   
                <dt class="rew19_paymentDt">주문회원 정보</dt>
                <dd>
                    <div class="rew19_completeCont">
                        <ul class="rew19_completeLine">
                            <li class="tit"><strong>{{getMemberNmKr()}}</strong></li>
                        </ul>
                    </div><!--//rew19_completeCont-->
    
                </dd>
                <dt v-if="viewData.showDeliveryInfo" class="rew19_paymentDt">배송정보</dt>
                <dd v-if="viewData.showDeliveryInfo">
                    <div class="rew19_completeCont">
                        <ul class="rew19_completeLine">
                            <li class="tit">
                                <em class="scard"><strong>{{viewData.ship_name}}</strong></em> 
                                <span id="txtShip_phone">{{viewData.ship_phone}}</span>
                            </li>
                            <li>
                                ({{viewData.postal_cd}}) {{viewData.home_addr}} {{viewData.home_addr_detail}}
                            </li>
                        </ul>
                    </div><!--//rew19_completeCont-->
                </dd>
                <dt class="rew19_paymentDt">결제정보</dt>
                <dd>
                    <div class="rew19_completeCont">
                        <ul class="rew19_completeLine">
                            <template v-if="viewData.payment_typ == '2'">
                                <li class="tit">
                                    <em class="scard"><strong>신용카드</strong></em> 
                                    <span>({{viewData.print_ccard_no}})</span>
                                </li>
                                <li v-if="mode != 'NTC'">
                                    <em class="scard">할부개월</em>
                                    <span v-if="viewData.inst_month == '00'">일시불</span>
                                    <span v-else-if="viewData.inst_month != '00'">{{viewData.inst_month}}개월</span>

                                </li>
                                <li>
                                    <span>{{$fmt.WON(viewData.payment_amt)}}</span>원
                                </li>
                            </template>
                            <template v-else-if="viewData.payment_typ == '3'">
                                <li class="tit">
                                    <em class="scard"><strong>계좌 자동이체</strong></em> 
                                    <span>({{viewData.print_bank_account}})</span>
                                </li>
                                <li>
                                    <span>{{$fmt.WON(viewData.payment_amt)}}</span>원
                                </li>
                            </template>
                        </ul>
                    </div><!--//rew19_completeCont-->
                </dd>
            </dl>
        </div>
    </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import { mapState } from "vuex";
import * as Const from "@/utils/const";

export default {
  name: "AroResult",
  extends: AroBase,
  props: {
    mode: {
      type: String,
      default : "" //
    },
    paymentCase: {
      type: String,
      default: "1"
    }
  },
  computed: {
    ...mapState("app", [
      "aroApplyResult",
      "aroNtcAppltResult",
      "memberBirthDt"
    ]),
    aroApplyResult: {
      get() {
        return this.$store.state.app.aroApplyResult;
      }
    },
    aroNtcApplyResult: {
      get() {
        return this.$store.state.app.aroNtcApplyResult;
      }
    },
    memberBirthDt: {
      get() {
        return this.$store.state.app.memberBirthDt;
      }
    }
  },
  data: () => ({
    //View Data 
    viewData: {
        showDeliveryInfo: true
    }
  }),
  created() {
   
  },

  mounted() {
     let _this = this;
    
    switch(_this.mode){
    case Const.ARO_BASKET_MODE:
    case Const.ARO_15_BASKET_MODE:
      _this.viewData = {..._this.aroApplyResult};
      _this.showDeliveryInfo = true;
      break;
    case Const.ARO_NTC_BASKET_MODE:
      _this.viewData = {..._this.aroNtcApplyResult};
      _this.viewData.payment_typ = "2";
      _this.viewData.payment_amt = _this.viewData.totalPrice;
      _this.showDeliveryInfo = false;
      break;
    }

    _this.checkAnniversary();

  },

  methods: {
    apiAnniversary(){
        let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/anniversary_check`, {
          params : {
              birth_dt : _this.memberBirthDt
          }
      });
    },
    goMyDetail(mode) {
        let _this = this;
        
        if(mode == Const.ARO_BASKET_MODE){
            _this.$router.push(`${_this.$aroBasePath}/aroDetail?aro_no=${_this.viewData.aro_no}`);
        }else{
            _this.$router.push(`${_this.$aroBasePath}/ntcCurrentDetail`);
        }
    },
    checkAnniversary(){
        let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiAnniversary().then(res=>{
        
        if (res.status === 200 && res.data.status === Const.ARO_DATA_API_SUCCESS) {
            
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        }
      }).catch((err)=>{
        console.error(err); 

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/product/result.vue